import { render } from "./MembershipPlans.vue?vue&type=template&id=d22d620a"
import script from "./MembershipPlans.vue?vue&type=script&lang=js"
export * from "./MembershipPlans.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__